import { ToastCustom } from "@components";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { submitInsightHelpful } from "../services";
import { INSIGHTS_QUERY_KEY } from "./insight-query-keys";

export type SubmitInsightHelpfulVariables = {
	insightId: number;
	wasHelpful: boolean;
};

const getErrorMessage = (error: unknown) => {
	if (error instanceof Error) {
		return error.message;
	}

	return "Não foi possível enviar seu feedback.";
};

export const useSubmitInsightHelpfulMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({ insightId, wasHelpful }: SubmitInsightHelpfulVariables) =>
			submitInsightHelpful(insightId, wasHelpful),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: [INSIGHTS_QUERY_KEY] });
		},
		onError: (error) => {
			toast(
				ToastCustom({ description: getErrorMessage(error), title: "Erro" })
			);
		},
	});
};
